export default {
  data() {
    return {
      likingIds: [],
    }
  },
  methods: {
    onLike(evaluation) {
      if (this.likingIds.includes(evaluation.id)) return
      const isLiked = this.likeIds.includes(evaluation.id)
      this.likingIds = [...this.likingIds, evaluation.id]
      const request = isLiked
        ? this.$axios.post(`/mandala_goal_self_evaluations/${evaluation.id}/dislike/`)
        : this.$axios.post(`/mandala_goal_self_evaluations/${evaluation.id}/like/`)
      request
        .then(() => {
          this.likeIds = isLiked
            ? this.likeIds.filter(id => id !== evaluation.id)
            : [...this.likeIds, evaluation.id]
        })
        .finally(() => {
          this.likingIds = this.likingIds.filter(id => id !== evaluation.id)
        })
    },
  },
}
